export const functionNoop: <T>(...args: T[]) => undefined = () => undefined;
